module.exports = __webpack_public_path__ + "media/images/c_1-6c0c84817aaf6cbc6fae803c5baef139.png";